// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"086213ae","247":"7f9d64db","513":"522d8c26","625":"84efc53e","706":"cc727622"}[chunkId] + ".chunk.js";
};